import React from "react";
import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Hero.css"; // Importamos los estilos

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="heroPosicion">
        <img src="img/marca/logoBlanco.png" alt="Whisky & Co." className="hero-logo" />
        <h1 className="hero-title">APASIONADOS POR <br className="soloMobile" />EL WHISKY</h1>
        <div className="contenedorBotonesHeroI">
            <Button as={Link} to="/productos" className="hero-btn ocultarMobile">Explora nuestra exclusiva selección de whiskies.</Button>
            <Button as={Link} to="/productos" className="hero-btn ocultarPcH">Explora nuestros whiskies.</Button>

          </div>
       
      </div>

    </section>
  );
};

export default Hero;
